import { useState, useEffect, useRef } from 'react'
import Modal from '@components/Modal'
import Button from '@components/Button'
import styles from './styles.module.scss'

const OnDemandParkingActivatedModal = ({ isActivated }) => {
    const [showModal, setShowModal] = useState(false)
    const prevIsActivatedRef = useRef(isActivated)

    useEffect(() => {
        // Show modal only when transitioning from false to true
        if (!prevIsActivatedRef.current && isActivated) {
            setShowModal(true)
        }
        prevIsActivatedRef.current = isActivated
    }, [isActivated])

    if (!showModal) return null

    return (
        <Modal size="large" onClose={() => setShowModal(false)}>
            <div className="d-flex flex-column align-items-center">
                <div className={styles.introGif} />
                <h3 className="font-weight-bold mb-3">
                    <T>dashboard.on.demand.parking.activated.title</T>
                </h3>
                <p className="text-large text-center mb-5">
                    <T>dashboard.on.demand.parking.activated.description</T>
                </p>
                <Button onClick={() => setShowModal(false)}>
                    <T>dashboard.on.demand.parking.activated.confirm</T>
                </Button>
            </div>
        </Modal>
    )
}

export default OnDemandParkingActivatedModal
